var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "layout",
    { attrs: { breadcrumbs: _vm.breadcrumbs } },
    [
      _c("template", { slot: "header" }, [
        _c("h1", { staticClass: "text-center" }, [
          _vm._v("\n            Compare Trims\n        ")
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "compare-boxes d-flex" },
        _vm._l(_vm.compareSelectedTrims, function(trim) {
          return _c("div", { key: trim.id, staticClass: "compare-box" }, [
            _c("div", { staticClass: "card-buttons" }, [
              _c("div", { staticClass: "inventory-available" }, [
                _vm._v("\n                    122 Available\n                ")
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "vehicle-image" },
              [_c("trim-image", { attrs: { trim: trim } })],
              1
            ),
            _vm._v(" "),
            _c("h1", [
              _vm._v(
                "\n                " +
                  _vm._s(trim.year) +
                  " " +
                  _vm._s(trim.make.name) +
                  " " +
                  _vm._s(trim.model.name) +
                  "\n            "
              )
            ]),
            _vm._v(" "),
            _c("h2", [_vm._v(_vm._s(trim.trim))]),
            _vm._v(" "),
            _c("div", { staticClass: "vehicle-info" }, [
              _c("p", [_vm._v("Engine: " + _vm._s(trim.engineDisplacement))]),
              _vm._v(" "),
              _c("p", [
                _vm._v("Transmission: " + _vm._s(trim.transmissionDescription))
              ]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(trim.drivetrain))])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "starting-at" }, [
              _c("div", { staticClass: "label" }, [
                _vm._v("\n                    Starting at\n                ")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "price" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm._f("numeral")(trim.startingMsrp, "$0,0")) +
                    "\n                "
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "cta" }, [
              _c("a", { attrs: { href: "#" } }, [
                _vm._v("\n                    Build & Price\n                ")
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mpg-block" }, [
              _c("div", { staticClass: "label" }, [
                _vm._v(
                  "\n                    EPA Estimated MPG:\n                "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "values" }, [
                _c("div", { staticClass: "mpg" }, [
                  _c("div", { staticClass: "value" }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(trim.cityMpg) +
                        "\n                        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "label" }, [
                    _vm._v(
                      "\n                            CITY\n                        "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "slash" }, [
                  _vm._v("\n                        /\n                    ")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "mpg" }, [
                  _c("div", { staticClass: "value" }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(trim.hwyMpg) +
                        "\n                        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "label" }, [
                    _vm._v(
                      "\n                            HWY\n                        "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "slash" }, [
                  _vm._v("\n                        /\n                    ")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "mpg" }, [
                  _c("div", { staticClass: "value" }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(trim.avgMpg) +
                        "\n                        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "label" }, [
                    _vm._v(
                      "\n                            AVG\n                        "
                    )
                  ])
                ])
              ])
            ])
          ])
        }),
        0
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }